import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  AlloysPanel,
  ServicesPanel,
  TitlePanel,
  AboutPanel,
  ContactPanel,
} from "../Panels";

const Main = ({ setSnackbar }) => {
  let defaultForm = {
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  };

  const [contactDetails, setContactDetails] = useState(defaultForm);
  const [isSaving, setIsSaving] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaKey, setCaptchaKey] = useState(0);

  const handleChange = ({ target }) => {
    setContactDetails({ ...contactDetails, [target.name]: target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setSnackbar({ message: "Please complete the verification to send" });
      return;
    }

    setIsSaving(true);

    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...contactDetails, captchaToken }),
    };

    fetch("/services/mailer", requestMetadata)
      .then((response) => {
        if (response.ok) {
          setSnackbar({ message: "Information request sent" });
          setContactDetails(defaultForm);
        } else {
          setSnackbar({
            message: "Unable to send your request, please try again",
          });
        }
      })
      .catch(() => {
        setSnackbar({ message: "Unable to send your request, please try again" });
      })
      .finally(() => {
        setIsSaving(false);
        // a token can only be used once, so always request a fresh challenge
        setCaptchaToken("");
        setCaptchaKey((key) => key + 1);
      });
  };

  return (
    <>
      <div className="site-inner">
        <div className="content-sidebar-wrap">
          <main className="content">
            <TitlePanel />
            <AlloysPanel />
            <ServicesPanel />
            <AboutPanel />
            <ContactPanel
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              isSaving={isSaving}
              contactDetails={contactDetails}
              captchaKey={captchaKey}
              onCaptchaChange={setCaptchaToken}
            />
          </main>
        </div>
      </div>
    </>
  );
};

Main.propTypes = {
  setSnackbar: PropTypes.func.isRequired,
};

export default Main;
